<template>
    <div>
        <el-page-header class="page-header" @back="goBack" content="提现"></el-page-header>
        <el-form label-position="top" :model="form" :rules="rules" ref="form" label-width="120px" class="demo-ruleForm">
            <el-form-item label="提现金额" prop="money">
                <div style="display: flex; align-items: center;">
                    <el-input v-model="form.money" placeholder="请输入提现金额" clearable class="input_class"></el-input>
                    <el-button type="text" @click="allMoney" style="margin-left: 10px;">全部</el-button>
                </div>
            </el-form-item>
            <el-form-item label="提现账号" prop="account">
                <el-input v-model="form.account" placeholder="请输入提现的银行卡号" type="text" class="input_class"></el-input>
            </el-form-item>
            <el-form-item label="提现密码" prop="password">
                <div style="display: flex; align-items: center;">
                    <el-input v-model="form.password" placeholder="请输入提现密码" :type="passwordType"
                        class="input_class"></el-input>
                    <img src="~@/assets/images/60.png" alt="隐藏密码" v-if="passwordType == 'password'" class="show-pwd"
                        @click="showPwd" />
                    <img src="~@/assets/images/61.png" alt="显示密码" v-else class="show-pwd" @click="showPwd" />
                </div>
            </el-form-item>
            <el-form-item>
                <el-button class="submit-btn" type="primary" @click="submitForm('form')">提现</el-button>
            </el-form-item>
        </el-form>
        <div class="date-picker">
            <span>提现明细</span>
            <el-date-picker size="small" v-model="date" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" @change="handleDateChange"></el-date-picker>
        </div>
        <el-table :data="financialList" :border="true" style="width: 100%; margin: 20px 0;">
            <el-table-column label="明细" align="center">
                <template slot-scope="scope">
                    <span>余额提现</span>
                </template>
            </el-table-column>
            <el-table-column prop="cash_fee" label="提现金额（元）" align="center">
            </el-table-column>
            <el-table-column prop="status_txt" label="提现状态" align="center">
            </el-table-column>
            <el-table-column prop="account_type_name" label="账户类型" align="center">
            </el-table-column>
            <el-table-column prop="order_no" label="订单号" align="center"></el-table-column>
            <el-table-column prop="create_time" label="时间" align="center"></el-table-column>
        </el-table>
        <el-pagination layout="total, sizes, prev, pager, next, jumper" :total="total" :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize" :current-page="currentPage" @size-change="handleSizeChange"
            @current-change="handleCurrentChange"></el-pagination>
    </div>
</template>

<script>
export default {
    name: 'Withdrawal',
    props: {
        money: {
            type: [Number, String],
            default: 0
        }
    },
    data() {
        return {
            passwordType: 'password',
            form: {
                money: '',
                account: '',
                password: ''
            },
            rules: {
                money: [
                    { required: true, message: '请输入提现金额', trigger: 'blur' }
                ],
                account: [
                    { required: true, message: '请输入提现的银行卡号', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入提现密码', trigger: 'blur' }
                ]
            },
            date: [],
            financialList: [],// 财务明细数据
            total: 0,// 总条数
            currentPage: 1,// 当前页码
            pageSize: 10,// 每页条数
        }
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo;
        },
    },
    mounted() {
        this.getWithdrawalList();
    },
    methods: {
        showPwd() {
            this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
        },
        goBack() {
            this.$emit('goToComponent', 'FinancialHome');
        },
        allMoney() {
            this.form.money = this.money;
        },
        // 获取金额明细列表
        getWithdrawalList() {
            this.$api.getWithdrawalList({
                partner_id: this.userInfo.user_merchant_id,
                start_time: this.date[0],
                end_time: this.date[1],
                page: this.currentPage,
                list_rows: this.pageSize,
            }).then(res => {
                this.financialList = res.data;
                this.total = res.total
            }).catch(err => {
                this.$message.error(err)
            })
        },
        // 分页相关
        handleSizeChange(val) {
            this.pageSize = val;
            this.getWithdrawalList();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getWithdrawalList();
        },
        // 日期选择器改变事件
        handleDateChange() {
            this.currentPage = 1;
            this.getWithdrawalList();
        },
        submitForm() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    this.$api.shopWithdrawal({
                        money: this.form.money,
                        account: this.form.account,
                        password: this.form.password,
                    }).then(res => {
                        this.$message({
                            message: '提现申请成功',
                            type: 'success'
                        });
                        this.getWithdrawalList();
                    }).catch(err => {
                        this.$message.error(err)
                    })
                } else {
                    this.$message({
                        message: '请填写完整信息',
                        type: 'error'
                    });
                }
            });
        }
    }
}
</script>

<style scoped>
.page-header {
    margin-bottom: 20px;
}

.input_class {
    width: 500px;
}

.demo-ruleForm {
    text-align: left;
}

.submit-btn {
    width: 200px;
    background: #286CED;
    border-radius: 6px 6px 6px 6px;
    margin-top: 20px;
}

.date-picker {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.show-pwd {
    cursor: pointer;
    user-select: none;
    width: 24px;
    height: 24PX;
    margin-left: 10px;
}
</style>